import defaultBrandJson from '../../brand/default.json';

/** Colours of a brand as configured; the full palette is derived from `primary` (ADR 0009 §5). */
export interface BrandColors {
  primary: string;
  primaryStrong: string;
  ink: string;
  cream: string;
}

export type BrandAssetKey = 'mark' | 'wordmarkLight' | 'wordmarkDark' | 'favicon' | 'icon' | 'adaptiveIcon' | 'splash' | 'notificationIcon';

/** A brand as the clients and the gateway see it: display name, tagline per language, colours and artwork. */
export interface Brand {
  id: string;
  name: string;
  tagline: { tr: string; en: string };
  colors: BrandColors;
  /** Paths relative to this package's root. */
  assets: Record<BrandAssetKey, string>;
}

/** The default brand (Posta Merkezi). Customer brands served by the gateway override it at runtime. */
export const defaultBrand: Brand = defaultBrandJson;
